export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";